import type { ILandingTemplateButton } from './landingTemplateButtons'
import type { CustomModuleBaseTypeEnum } from '~/shared/api'
import { normalizeWorkspaceModuleSlug } from './workspaceModuleVisibility'

export interface ILandingCustomModuleNavRef {
  moduleSlug: string
  moduleType: CustomModuleBaseTypeEnum
}

export function resolveLandingCustomModuleFromButton(
  button: Pick<ILandingTemplateButton, 'moduleSlug' | 'moduleType'>,
): ILandingCustomModuleNavRef | null {
  if (!button.moduleType) {
    return null
  }

  return {
    moduleSlug: normalizeWorkspaceModuleSlug(button.moduleSlug),
    moduleType: button.moduleType,
  }
}
